module.exports = __webpack_public_path__ + "img/headerenimg.7bc5d0a5.png";